// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"9afc1f14","276":"8a1b7908","434":"161fb24e","453":"5265ae8d","503":"832f40f7","706":"8bdbdd9b","839":"6793d6b2","849":"1167a8ce","907":"2b7b58a8","968":"ef4704b7","974":"f67682cd"}[chunkId] + ".chunk.js";
};